var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "composer-ditar-espectro",
      attrs: { "data-teste": "composer-ditar-espectro", "aria-hidden": "true" }
    },
    _vm._l(_vm.alturas, function(altura, indice) {
      return _c("span", {
        key: indice,
        staticClass: "composer-ditar-espectro__barra",
        style: { height: altura + "px" }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }